import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';

import { useNavigate } from 'react-router-dom'

//var dateFormat = require('dateformat');


const RenderWpForm = () => {

const customspremurl=sessionStorage.getItem("CUSTOMSPREMURL");
const resturl=sessionStorage.getItem("RESTURL");	
const scansurl=sessionStorage.getItem("SCANSURL");

//var boolFetchingSads=false;

const navigate = useNavigate();


const [dowait, setDowait] = useState({show:false});
const [wptapp, setWptapp] = useState({
	WPT_APP_ID:''
	, BOARD_REMARKS:''
	});
const [tblwptapps, setTblwptapps] = useState([]);
const [wptappstatusoptions, setWptappstatusoptions] = useState([]);

const [dlwait, setDlwait] = useState({show:false});

const [crit, setCrit]= useState({
	dosearch:0
	, lcid:""
	,sta:""
	,agc:""
	,mpr:""
	,ref:""
	,mpe:""
	,job:""
	,date1:""
	,date2:""
	});

//tblwptapps

const location = useLocation();


useEffect(() => {
	
if (sessionStorage.getItem("USERNAME")==null || sessionStorage.getItem("USERNAME")=="null" || sessionStorage.getItem("USERNAME")==undefined || sessionStorage.getItem("USERNAME")==""){
	navigate("/");
	return;
	}//end if	
	
document.title =   "Board Applications";	
getboardwptapps();

 },[]);


 
 useEffect(() => {

//console.log(JSON.stringify(crit));
if (crit.dosearch==1){
	if (crit.showbtnclear==1)
		document.getElementById("btnclearcrit").classList.remove("hidden");
	setCrit((prev)=>{return {...prev, dosearch:0}});
	getboardwptapps();
	}//end if
	

 },[crit]);

useEffect(() => {

//document.getElementById("button1").style.visibility=wptapps.length==0?"hidden":"visible";

 },[JSON.stringify(tblwptapps)]);

function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func

function critChange(e){
const {name, value}	=e.target;
console.log("critChange: "+name+" "+value);
	
const dosearch=(name.startsWith("date") || (value.length>0 && value.length<3) )? 0:1;

if (name.startsWith("date") && document.getElementById("btnsearch"))
	document.getElementById("btnsearch").classList.remove("hidden");
	

if (!name.startsWith("date") && value.length<3)
	setTblwptapps([]);

	setCrit((prev)=>{
		return {...prev, [name]:value, dosearch:dosearch, showbtnclear:1}
	});
	
}//end func

function handleChange(e){
const {name, value}	=e.target;
console.log("handleChange: "+name+" "+value);

	setWptapp((prev)=>{
		return {...prev, [name]:value}
	});

}//end func
async function getwptappstatusoptions(){
		
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {} )
  };		

setWptappstatusoptions([]);

  await fetch(resturl+'rarwpform/getwptappstatusoptions',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetwptappstatusoptions(res) )	
	
}//end func

function aftergetwptappstatusoptions(res){
	
console.log("aftergetwptappstatusoptions: "+res.length);

if (!res.length)
	return;

let tempopts=[<option value='' ></option>];

res.map((col, index) => {
	const STATUS_CODE=col['STATUS_CODE'];
	const key="combosta_"+index;
	tempopts.push(<option key={key} value={STATUS_CODE}  >{col['WPT_STATUS']}</option>);

	});//end map
setWptappstatusoptions(tempopts);

}//end func


async function setlbrclrbrdrmks(e){
		
const params={
	username:sessionStorage.getItem("USERNAME")
	, remarks:wptapp.BOARD_REMARKS
	, WPT_APP_ID:wptapp.WPT_APP_ID
	};
		
	e.target.classList.add("hidden");
	
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

  await fetch(resturl+'rarwpform/setlbrclrbrdrmks',requestOptions)
      .then(res => res.json())
      .then(res => 	aftersetlbrclrbrdrmks(res, e) )	
	
}//end func

async function aftersetlbrclrbrdrmks(res, e){
	
e.target.classList.remove("hidden");
console.log("aftersetlbrclrbrdrmks: "+res.length);

if (!res.length){
	showsnackbar("something went wrong.  please try again or contact admin");
	return;
	}

setWptapp((prev)=>{
	return {...prev
	, BOARD_REMARKS:res[0].BOARD_REMARKS
	, BRD_RMKS_MODIFIED:res[0].BRD_RMKS_MODIFIED
	}
	});

set_lbr_clr_app_board_remarks();

}//end func


async function set_lbr_clr_app_board_remarks(){
	
const params={
	lbr_clr_app_id:wptapp.IPM_LBR_CLR_APP_ID
	, updated_by:"dlglinton"
	, board_remarks:wptapp.BOARD_REMARKS
	};
		
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

  await fetch(customspremurl+'rarmssql/set_lbr_clr_app_board_remarks',requestOptions)
      .then(res => res.json())
      .then(res => 	afterset_lbr_clr_app_board_remarks(res) )	
	
}//end func

function afterset_lbr_clr_app_board_remarks(res){
//nothing is returned so do nothing	
}//end func

async function getboardwptapps(){
		setTblwptapps([]);
		
		if (crit.CREATE_USER=="")
			return;
		
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {USERNAME:sessionStorage.getItem("USERNAME"), crit} )
  };		

  await fetch(resturl+'rarwpform/getboardwptapps',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetboardwptapps(res) )	
	
}//end func

function aftergetboardwptapps(res){
	
console.log("aftergetboardwptapps: "+res.length);

if (!res.length)
	return;

let temp=[];

res.map((col, index) => {
	//if (index==0){
	const MPR_NAME=col['MPR_NAME'];
	
	const WPT_APP_ID=col['WPT_APP_ID'];
	const refnum=col['REF_NUM'];
	const rowId="row_"+index;
	const trkey="tblwptapp_tr_"+index;
	const currapp={
		WPT_APP_ID:WPT_APP_ID
		,IPM_LBR_CLR_APP_ID:col['IPM_LBR_CLR_APP_ID']
		,IMG_REF:col['IMG_REF']
		,MPR_NAME:MPR_NAME
		,MPE_NAME: col['MPE_NAME']
		,MPE_OCCUPATION:col['MPE_OCCUPATION']
		,BOARD_REMARKS:col['BOARD_REMARKS']?col['BOARD_REMARKS']:""
		,BRD_RMKS_MODIFIED:col['BRD_RMKS_MODIFIED']
	};
	
	temp.push(<tr key={trkey} id={rowId} >
	<td align='right' >{""+(1+index)}</td>
	<td align='center' >{col['STATUS']}</td>
	<td align='left' >{col['AGENCY'].substring(0,26)}</td>
	<td align='left' >{MPR_NAME.substring(0,26)}</td>
	<td align='left' >
		<a href="#" title="click here for board remarks" onClick={(e)=>{openBoardremarks(e, currapp,rowId,res.length);}} className="nodecor"  ><img src="img/openfolderarrow.png" border="0" />{col['IPM_LBR_CLR_APP_ID']}</a>
	</td>
		{/*<td align='left' >{col['MPR_TEL_NBR']}</td>*/}
	<td align='center' >{col['IMG_REF']}</td>
	<td align='left' ><a href="#" title="click here to see scanned documents" onClick={(e)=>{openScans(e, WPT_APP_ID, refnum, "scans.pdf");}} className="nodecor" ><img src='img/pdf.gif' border='0' /> {col['MPE_NAME'].substring(0,26)}</a></td>
	<td align='left' >{col['MPE_OCCUPATION']}</td>
		{/*<td align='right' className="tooltip" >{voucherLink}&nbsp;</td>*/}
	<td align='center' >{col['TC_SUBMITTED_TO_CSC']}</td>
	</tr>);	
	
	});
	
setTblwptapps(temp);	
if (wptappstatusoptions.length==0)
	getwptappstatusoptions();
setCrit((prev)=>{
	return {...prev
		, date1:res[0].SDATE1
		, date2:res[0].SDATE2
		}
	});
}//end func


function openBoardremarks(e, currapp, rowId, len){
e.preventDefault();	
const test='abc';
 
toggleModalsm();

setWptapp((prev)=>{
	return {...prev
	, IPM_LBR_CLR_APP_ID:currapp.IPM_LBR_CLR_APP_ID
	, WPT_APP_ID:currapp.WPT_APP_ID
	, MPR_NAME:currapp.MPR_NAME
	, IMG_REF:currapp.IMG_REF
	, MPE_NAME:currapp.MPE_NAME
	, MPE_OCCUPATION:currapp.MPE_OCCUPATION
	, BOARD_REMARKS:currapp.BOARD_REMARKS
	, BRD_RMKS_MODIFIED:currapp.BRD_RMKS_MODIFIED
	}
	});

console.log("len: "+len);




for (var i=0; i<len; i++){
	const rowIdtemp="row_"+i;
	if (rowIdtemp==rowId){
		console.log("rowIdtemp: "+rowIdtemp);
		if (!document.getElementById(rowIdtemp).classList.contains("bgyellow"))
			document.getElementById(rowIdtemp).classList.add("bgyellow");
		}
	else{
		if (document.getElementById(rowIdtemp).classList.contains("bgyellow"))
			document.getElementById(rowIdtemp).classList.remove("bgyellow");
		}

		
	}//end for



}//end func


function toggleModalsm() {
/*
const modalsm = document.querySelector(".modalsm");
const trigger = document.querySelector(".trigger");
const closeButton = document.querySelector(".close-button");
console.log('modalsm is null: '+(document.querySelector(".modalsm")==null));
*/	

if (document.querySelector(".modalsm")){
	const modalsm=document.querySelector(".modalsm");
	modalsm.classList.toggle("show-modalsm");
	/*
	a problem occurs sometimes when the popup window does not close when the x button is clicked
	below we log to check if modalsm still contains the show-modalsm class
	modalsm.classList.contains('show-modalsm'): false
	modalsm.classList.contains('show-modalsm'): true
	the event fires twice in the logs.  conclusion is theres overlap of button and window events when button is clicked
	Found that there was a second line of code calling closeButton.addEventListener("click", toggleModalsm);
	Problem solved after removing that second call to closeButton.addEventListener("click", toggleModalsm);
	console.log("modalsm.classList.contains('show-modalsm'): "+modalsm.classList.contains("show-modalsm"));
	*/
	
	
	
	if (modalsm.classList.contains("show-modalsm")){
		//when the popup opens, focus emailmsg and addEventListeners 
		//document.getElementsByName('EML_MSG')[0].focus();
		//document.getElementsByName('EML_MSG')[0].value='';
		
		if (document.querySelector(".close-button")){
			const closeButton = document.querySelector(".close-button");
			if(!closeButton.classList.contains('attached-listener')){
				closeButton.classList.add('attached-listener');
				closeButton.addEventListener("click", toggleModalsm);
				window.addEventListener("click", windowOnClick);
				}//end if
			}//end if
	
		}//end if
	}//end if



}//end func

function windowOnClick(event) {
const modalsm = document.querySelector(".modalsm");
const trigger = document.querySelector(".trigger");
const closeButton = document.querySelector(".close-button");	
	
	
	
    if (event.target === modalsm) {
		//console.log("will call toggleModalsm() from inside windowOnClick(event)");
    	toggleModalsm();
    }
}//end func



async function openScans(e, WPT_APP_ID, REF_NUM, filename) {
e.preventDefault();

const relFilepath=REF_NUM+"/"+filename;

const params={
	filepath:relFilepath
	, TBL: "WPT"
	, WPT_APP_ID: WPT_APP_ID
	, AD_USER:sessionStorage.getItem("AD_USER")
	, FILENAME: filename
	, FLAG_DL: 1
	};
    const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };

		setDlwait({show:true});
	
 await fetch(scansurl+'rarwpform/getwptappfile',requestOptions)
      .then(res => afteropenScans(res, REF_NUM, filename))
      .catch(err => console.log(err));


}//end func

async function afteropenScans(res, REF_NUM, filename){
const downloadFilename = REF_NUM+"_"+filename;
const blob = await res.blob();
//console.log('blob.length: '+blob.length);
const data = window.URL.createObjectURL(new Blob([blob]));

const link = document.createElement("a");
link.href = data;
link.setAttribute("download", downloadFilename);
document.body.appendChild(link);
link.click();
//link.parentNode!.removeChild(link);	
link.parentNode?.removeChild(link);	

setDlwait({show:false});


}//end func

function clickdatesearch(e){
e.preventDefault(); 
document.getElementById("btnsearch").classList.add("hidden");
setCrit((prev)=>{return {...prev, dosearch:1}});	
	
}//end func

function clearsearch(e){
	e.preventDefault();

	setCrit({
	dosearch:1
	,showbtnclear:0
	,sta:""
	,agc:""
	,mpr:""
	,ref:""
	,mpe:""
	,job:""
	,date1:""
	,date2:""
	});
	document.getElementById("btnclearcrit").classList.add("hidden");
	
}//end func
//DHC General Contractors

  return (
    <>


<p align="center" className="Acme" style={{marginBottom:"6px", marginTop:"9px", color:"brown",fontSize:"24px"}} >Labour Clearance Applications for Board Approval</p>
<table align="center" >
<tbody>
<tr>
	<td align="right" >from date:</td>
	<td align="left" ><input name="date1" value={crit.date1} onChange={(e)=>{critChange(e);}} type="date" /></td>
</tr>
<tr>
	<td align="right" >to date:</td>
	<td align="left" ><input name="date2" value={crit.date2}  onChange={(e)=>{critChange(e);}} type="date" /></td>
	<td align="center" width="20" >&nbsp;</td>
	<td align="right" ><a href="#" id="btnsearch" className="nodecor hidden" onClick={(e)=>{ clickdatesearch(e); }} ><img src="img/magnify_glass.png" height="22" border="0" /> apply date filter</a></td>
</tr>

<tr>
	<td align="right" ></td>
	<td align="left" >&nbsp;</td>
</tr>
</tbody>
</table>
	<table align='center' className="customers" style={{width:"95%"}} id="tblresults" >
	<thead>
	<tr>
		<td align="center" >&nbsp;</td>
		<td align="center" ><select name="sta" value={crit.sta} onChange={(e)=>{critChange(e);}} style={{width:"120px"}} >{wptappstatusoptions}</select></td>
		<td align="left" ><input name="agc" value={crit.agc} onChange={(e)=>{critChange(e);}} placeholder="agency" className="bgyellow" onFocus={(e)=>{e.target.select();}} autoComplete="off" /></td>
		<td align="left" ><input name="mpr" value={crit.mpr} onChange={(e)=>{critChange(e);}} placeholder="employer" className="bgyellow" onFocus={(e)=>{e.target.select();}} autoComplete="off" /></td>
		<td align="left" ><input name="lcid" value={crit.lcid} onChange={(e)=>{critChange(e);}} size="3" placeholder="Id#" className="bgyellow" onFocus={(e)=>{e.target.select();}} autoComplete="off" /></td>
		<td align="left" ><input name="ref" value={crit.ref} onChange={(e)=>{critChange(e);}} placeholder="immig. ref #" className="bgyellow" onFocus={(e)=>{e.target.select();}} autoComplete="off" size="5" /></td>
		<td align="left" ><input name="mpe" value={crit.mpe} onChange={(e)=>{critChange(e);}} placeholder="applicant" className="bgyellow" onFocus={(e)=>{e.target.select();}} autoComplete="off" /></td>
		<td align="left" ><input name="job" value={crit.job} onChange={(e)=>{critChange(e);}} placeholder="occupation" className="bgyellow" onFocus={(e)=>{e.target.select();}} autoComplete="off" /></td>
		<td align="center" ><a href="#" id="btnclearcrit" className="hidden"  onClick={(e)=>{clearsearch(e);}} >clear search</a></td>
	</tr>
	<tr>
		<th>#</th>
		<th>status</th>
		<th>agency</th>
		<th>employer's name</th>
		{/*<th>employer's phone #</th>*/}
		<th>labour<br/>clear.<br/>Id#</th>
		<th>immig. ref. #</th>
		<th>applicant</th>
		<th>job title</th>
		<th>submitted</th>
	</tr>
	</thead>
	<tbody>
	{tblwptapps}
	</tbody>
	</table>
	


<div class="modalsm">
    <div class="modalsm-content">
        <span class="close-button">&times;</span>
        <div align='center' id='modalsmtext' >
			<table align='center'  >
			<tbody>
			<tr>
			<td align='center' colspan='2' className="boldbrown" >Labour Clearance Application with Id # {wptapp.IPM_LBR_CLR_APP_ID}</td>
			</tr>
			<tr>
			<td align='right' >Immigration Ref #:</td>
			<td align='left' >{wptapp.IMG_REF}</td>
			</tr>
			<tr>
			<td align='right' >Employer:</td>
			<td align='left' >{wptapp.MPR_NAME}</td>
			</tr>
			<tr>
			<td align='right' >Worker:</td>
			<td align='left' >{wptapp.MPE_NAME}</td>
			</tr>
			<tr>
			<td align='right' >Occupation:</td>
			<td align='left' >{wptapp.MPE_OCCUPATION}</td>
			</tr>
			<tr>
			<td align='right' >Board Remarks:</td>
			<td align='left' ><textarea rows='5' cols='40' name="BOARD_REMARKS" value={wptapp.BOARD_REMARKS} onChange={(e)=>{handleChange(e);}} >{wptapp.BOARD_REMARKS}</textarea></td>
			</tr>
			<tr>
			<td align='right' ></td>
			<td align='left' >
				<table align='center' border="0" cellspacing="0" cellpadding="0" >
				<tbody>
				<tr>
					<td align='center' ><button class='button' onClick={(e)=>{setlbrclrbrdrmks(e);}} >save changes</button></td>
					<td align='center' >&nbsp;&nbsp;{wptapp.BRD_RMKS_MODIFIED}</td>
				</tr>
				</tbody>
				</table>
			</td>
			</tr>
			</tbody>
			</table>
		
		</div>
    </div>
</div>

<div id="snackbar">&nbsp;</div>
    </>
  );
  



};



export default RenderWpForm;